import React, { useEffect, useState } from 'react';
import api from '../api';

// Hardcoded rates (for demo)
const RATES = { ETH: 1770, BTC: 63035, USDT: 1 };

function AssetVault() {
  const [assets, setAssets] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [txTab, setTxTab] = useState('all');

  useEffect(() => {
    api.get('/api/assets/my-assets').then(res => setAssets(res.data));
    api.get('/api/assets/transactions').then(res => setTransactions(res.data));
  }, []);

  const filteredTx = transactions.filter(tx => {
    if (txTab === 'incoming') return tx.type === 'deposit';
    if (txTab === 'release') return tx.type === 'release';
    return true;
  });

  const getCurrencySymbol = (currency) => {
    if (currency === 'ETH') return 'ETH';
    if (currency === 'BTC') return 'BTC';
    if (currency === 'USDT') return 'USDT';
    return currency || 'ETH';
  };

  const getUSDValue = (asset) => {
    const rate = RATES[asset.currency] || 1770;
    return (asset.amount * rate).toFixed(2);
  };

  const getStatusStyle = (asset) => {
    if (asset.status === 'vault_storage') return 'green';
    if (asset.status === 'asset_transfer') return 'gray';
    return 'orange';
  };

  const getStatusLabel = (asset) => {
    if (asset.status === 'vault_storage') return 'Protected';
    if (asset.status === 'asset_transfer') return 'Transferred';
    return 'Under Review';
  };

  const getVerificationLabel = (asset) => {
    if (asset.status === 'ownership_verification') return 'In Review';
    return 'Verified';
  };

  return (
    <div>
      <h2>Asset Vault</h2>
      <div className="tables-row">
        <div className="table-box">
          <h3>Protected Assets</h3>
          <table>
            <thead>
              <tr>
                <th>Asset</th>
                <th>Amount</th>
                <th>USD Value</th>
                <th>Status</th>
                <th>Verification</th>
              </tr>
            </thead>
            <tbody>
              {assets.map(asset => (
                <tr key={asset.id}>
                  <td>{getCurrencySymbol(asset.currency)}</td>
                  <td>{asset.amount} {asset.currency}</td>
                  <td>${getUSDValue(asset)}</td>
                  <td style={{ color: getStatusStyle(asset) }}>
                    {getStatusLabel(asset)}
                  </td>
                  <td>{getVerificationLabel(asset)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="table-box">
          <h3>Transaction Center</h3>
          <div className="tx-tabs">
            <button onClick={() => setTxTab('all')} className={txTab === 'all' ? 'active' : ''}>All</button>
            <button onClick={() => setTxTab('incoming')} className={txTab === 'incoming' ? 'active' : ''}>Incoming</button>
            <button onClick={() => setTxTab('release')} className={txTab === 'release' ? 'active' : ''}>Release</button>
          </div>
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Asset</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Date</th>
                <th>T ID</th>
              </tr>
            </thead>
            <tbody>
              {filteredTx.map(tx => (
                <tr key={tx.id}>
                  <td style={{ color: tx.type === 'deposit' ? 'green' : 'red' }}>{tx.type}</td>
                  <td>{tx.currency || 'ETH'}</td>
                  <td>{tx.amount}</td>
                  <td>{tx.status}</td>
                  <td>{new Date(tx.createdAt).toLocaleDateString()}</td>
                  <td>{tx.txHash?.slice(0, 10)}...</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AssetVault;